import {useState} from "react";
import {FiberCoverMapRegions, MapRegion} from "../coverageMap/CoverageMap.ts";
import CoverageMapContainer from "../coverageMap/CoverageMapContainer.tsx";
import {ProductListPrice} from "../../util/request.ts";
import {formatAmountWithCurrencyOverPeriod} from "../../util/formatter.ts";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";

export default function PriceListItemComponent(props: { region: MapRegion, title: string, products: ProductListPrice[] }) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <span className={`accordion${open ? ' active' : ''}`} onClick={() => setOpen((prev) => !prev)}>
                <h3 className="title title--montserrat">{props.title}</h3>
                <div className="symbol">
                    <span></span>
                    <span></span>
                </div>
            </span>
            <div className={`accordion-content-container${open ? ' active' : ''}`} style={{maxHeight: `${open ? '100%' : '0'}`}}>
                <div className="accordion-content prices-container">
                    <div className="coverage-map-wrapper">
                        <p>
                            Se område og bredbåndspriser på {props.title}
                        </p>
                        <CoverageMapContainer regionPreset={props.region} fiberMapOnly={false} static={true}/>
                    </div>

                    <table cellSpacing="0" className="prices-table">
                        <tbody>
                        {props.products.map((p, i) => {
                            return (
                                <tr key={i}>
                                    <td>{p.line_speed_down}/{p.line_speed_up} Mbit</td>
                                    <td>Fra {formatAmountWithCurrencyOverPeriod(p.price)}</td>
                                </tr>
                            )
                        })}
                        <tr>
                            <td className="prices-table-address-button" colSpan={2}>
                                <button
                                    className={'button button--montserrat rounded'}
                                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                                >
                                    Tjek prisen på din adresse
                                </button>
                                <p>Og se om du kan få billigt bredbånd</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export function PriceListTDCFiberComponent(props: { products: ProductListPrice[] }) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <div className={`accordion${open ? ' active' : ''}`} onClick={() => setOpen((prev) => !prev)}>
                <h3 className="title title--montserrat">TDC NET fiber</h3>
                <div className="symbol">
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div className={`accordion-content-container${open ? ' active' : ''}`} style={{maxHeight: `${open ? '100%' : '0'}`}}>
                <div className="accordion-content prices-container">
                    <div className="coverage-map-wrapper">
                        <p>
                            Se område og bredbåndspriser på TDC NET&rsquo;s fiber
                        </p>
                        <CoverageMapContainer regionPreset={FiberCoverMapRegions.FIBER_TDC} fiberMapOnly={false} static={true}/>
                    </div>

                    <table cellSpacing="0" className="prices-table">
                        <tbody>
                        <tr>
                            <td>{props.products[0].line_speed_down}/{props.products[0].line_speed_up} Mbit</td>
                            <td>
                                Fra {formatAmountWithCurrencyOverPeriod(props.products[0].price)}{' '}
                                <div className="tool-tip">
                                    &#9432;
                                    <span className="tool-tip-text">
                                        SMP: <b>{formatAmountWithCurrencyOverPeriod(props.products[0].price)}</b><br/>
                                        Non-SMP: <b>{formatAmountWithCurrencyOverPeriod(props.products[1].price)}</b><br/>
                                        <br/>
                                        SMP: Stærk Markedsposition
                                    </span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>{props.products[2].line_speed_down}/{props.products[2].line_speed_up} Mbit</td>
                            <td>
                                Fra {formatAmountWithCurrencyOverPeriod(props.products[2].price)}{' '}
                                <div className="tool-tip">
                                    &#9432;
                                    <span className="tool-tip-text">
                                        SMP: <b>{formatAmountWithCurrencyOverPeriod(props.products[2].price)}</b><br/>
                                        Non-SMP: <b>{formatAmountWithCurrencyOverPeriod(props.products[3].price)}</b><br/>
                                        <br/>
                                        SMP: Stærk Markedsposition
                                    </span>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td className="prices-table-address-button" colSpan={2}>
                                <button
                                    className={'button button--montserrat rounded'}
                                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                                >
                                    Tjek prisen på din adresse
                                </button>
                                <p>Og se om du kan få billigt bredbånd</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
